import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Bell from '../../../assets/icons/bell';
import Download from '../../../assets/icons/download';
import Add from '../../../assets/icons/add';
import * as css from './SubscriptionActions.css';
import setGlobalState from '../../../redux/setGlobalState';

function SubscriptionActions() {
    const {t} = useTranslation('subscriptions');

    return (
        <css.actions> 
            <Button data-cy="subscription-send-alerts-btn" onClick={() => {}} variant="neutral" size="chip" iconStart={<Bell />} disabled>{t('sendAlerts')}</Button>
            <Button data-cy="subscription-detailed-report-btn" onClick={() => {}} variant="neutral" size="chip" iconStart={<Download />} disabled>{t('detailedReport')}</Button>
            <css.separator />
            <Button data-cy="subscription-new-series-btn" onClick={() => {setGlobalState('ui.show.isOpenCreateSubscription', true);}} variant="brand" size="chip" iconStart={<Add />}>{t('newSeries')}</Button>
        </css.actions>
    );
}

export default SubscriptionActions;

